/**
 * theme.js — Urdile Shopify Theme
 * Utilidades globales reutilizadas por todos los módulos
 */

'use strict';

// ============================================================
// formatMoney — Formato CLP: $1.290.000 (punto como separador de miles)
// ============================================================
/**
 * @param {number} cents — precio en centavos (Shopify usa centavos)
 * @returns {string} — '$1.290.000'
 */
window.formatMoney = function formatMoney(cents) {
  if (typeof cents !== 'number') {
    cents = parseFloat(cents) || 0;
  }
  const amount = Math.round(cents / 100);
  // Formato chileno: punto como separador de miles, sin decimales
  const formatted = amount.toLocaleString('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return '$' + formatted;
};

// ============================================================
// debounce — evita disparar una función muchas veces seguidas
// ============================================================
/**
 * @param {Function} fn
 * @param {number} delay — ms
 * @returns {Function}
 */
window.debounce = function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};

// ============================================================
// trapFocus — atrapa el foco dentro de un container (accesibilidad)
// ============================================================
/**
 * @param {HTMLElement} container
 * @param {HTMLElement} [focusElement] — elemento que recibe el foco inicial
 */
window.trapFocus = function trapFocus(container, focusElement) {
  const FOCUSABLE_SELECTORS = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(', ');

  const focusableElements = Array.from(container.querySelectorAll(FOCUSABLE_SELECTORS));
  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  if (focusElement) {
    focusElement.focus();
  } else if (firstFocusable) {
    firstFocusable.focus();
  }

  function handleKeydown(event) {
    if (event.key !== 'Tab') return;

    if (event.shiftKey) {
      if (document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  }

  container.addEventListener('keydown', handleKeydown);
  container._trapFocusHandler = handleKeydown;
};

// ============================================================
// removeTrapFocus — elimina el trap de foco de un container
// ============================================================
/**
 * @param {HTMLElement} container
 */
window.removeTrapFocus = function removeTrapFocus(container) {
  if (container && container._trapFocusHandler) {
    container.removeEventListener('keydown', container._trapFocusHandler);
    delete container._trapFocusHandler;
  }
};

// ============================================================
// onKeyUpEscape — despacha evento 'close' al presionar Escape
// ============================================================
/**
 * Listener para el evento keyup en document.
 * Despacha evento 'close' en el elemento activo o en un target específico.
 * @param {KeyboardEvent} event
 */
window.onKeyUpEscape = function onKeyUpEscape(event) {
  if (event.key !== 'Escape') return;

  const openElements = document.querySelectorAll('[aria-expanded="true"]');
  openElements.forEach((el) => {
    el.dispatchEvent(new CustomEvent('close', { bubbles: true }));
  });
};

document.addEventListener('keyup', window.onKeyUpEscape);
